// frontend/src/components/UI/withLoading.jsx
import React, { useState, useEffect } from 'react';
import { LoadingScreen } from './LoadingScreen';

export const withLoading = (WrappedComponent) => {
  return function WithLoadingComponent(props) {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      const handleStartLoading = () => setIsLoading(true);
      const handleStopLoading = () => {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      };

      // Show loading on page refresh/navigation
      window.addEventListener('beforeunload', handleStartLoading);
      // Hide loading when page is loaded
      window.addEventListener('load', handleStopLoading);

      // Initial load
      handleStopLoading();

      return () => {
        window.removeEventListener('beforeunload', handleStartLoading);
        window.removeEventListener('load', handleStopLoading);
      };
    }, []);

    return (
      <div className="relative">
        <WrappedComponent {...props} />
        {isLoading && <LoadingScreen />}
      </div>
    );
  };
};

export default withLoading;